import React, { useState, useEffect, PropTypes } from "react"
import { Container, Col, Row, Form } from "react-bootstrap";
import Autosuggest from 'react-autosuggest';
import _ from "lodash"

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => `${suggestion.name} ${(suggestion.location) ? `(${suggestion.location})` : ''}`;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
    <div>
        {`${suggestion.name} ${(suggestion.location) ? `(${suggestion.location})` : ''}`}
    </div>
);

class SearchInputBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props?.value,
            suggestions: [],
            areas: props?.areaList || [],
            aliasVal: "",
            isChages: false
        };
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue,
            aliasVal: newValue,
            isChages: true
        });
        if (this?.props?.setSearchVal) {
            this.props.setSearchVal(newValue)
        }
    };

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };

    suggestionSelected = (e, { suggestion }) => {

        if (suggestion) {
            this.setState({
                value: suggestion.name,
                aliasVal: suggestion.name,
            });
            if (this?.props?.setSearchVal) {
                this.props.setSearchVal(suggestion.slug)
            }
        }
    }

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    // Teach Autosuggest how to calculate suggestions for any given input value.
    getSuggestions = value => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0 ? [] : this.state.areas.filter(area =>
            area.name.toLowerCase().slice(0, inputLength) === inputValue
        );
    };

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.areas.length && this.props.areaList.length) {
            this.setState({ areas: this.props.areaList })
        }
    }



    render() {
        const { value, suggestions, isChages, aliasVal } = this.state;

        // Autosuggest will pass through all these props to the input.
        var setVal = value;
        var setAliasVal = aliasVal;
        if (_.isEmpty(setVal) && !isChages && !_.isEmpty(this.props.areaVal)) {
            setVal = this.props.areaVal;
            setAliasVal = this.props.areaVal
        }

        const inputProps = {
            placeholder: 'Search Here',
            value: setVal,
            onChange: this.onChange,
            className: 'form-control postcode_input'
        };

        // Finally, render it!
        return (
            <div className="dropdown-exp d-lg-block">
                <Form.Group>
                    <Autosuggest
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={getSuggestionValue}
                        onSuggestionSelected={this.suggestionSelected}
                        renderSuggestion={renderSuggestion}
                        inputProps={inputProps}
                    // alwaysRenderSuggestions={true}
                    />
                    <i className="icon-search" />
                    <input type="hidden" className="searchVal" value={value || aliasVal} />
                </Form.Group>

            </div>
        );
    }
}

const SearchResultBoxWrap = (props) => {
    return (
        <SearchInputBox {...props} />
    )
}

export default SearchResultBoxWrap;